module.exports = __webpack_public_path__ + "img/IMG_1454_L_Wood_MockedUp.caae1daf.jpg";